import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

const avantages = [
  {
    icon: 'ri-temp-cold-line',
    title: 'Confort Optimal',
    description: 'Température idéale été comme hiver avec nos climatiseurs réversibles haute performance'
  },
  {
    icon: 'ri-leaf-line',
    title: "Économies d'Énergie",
    description: "Réduisez vos factures avec des systèmes classe A+++ jusqu'à 70% d'économies"
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Installation Certifiée',
    description: 'Pose conforme aux normes RGE avec garantie décennale pour votre tranquillité'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'SAV Réactif',
    description: 'Intervention rapide à Valence et alentour pour dépannage et entretien annuel'
  }
];

const marques = [
  { name: 'Daikin', icon: 'ri-star-fill', note: '5/5' },
  { name: 'Mitsubishi Electric', icon: 'ri-star-fill', note: '5/5' },
  { name: 'Atlantic', icon: 'ri-star-fill', note: '4.8/5' },
  { name: 'Toshiba', icon: 'ri-star-fill', note: '4.7/5' },
  { name: 'Panasonic', icon: 'ri-star-fill', note: '4.8/5' },
  { name: 'LG', icon: 'ri-star-fill', note: '4.6/5' },
];

const processus = [
  {
    numero: '01',
    titre: 'Diagnostic Gratuit',
    description: 'Visite à domicile pour évaluer vos besoins et la configuration de votre logement à Valence'
  },
  {
    numero: '02',
    titre: 'Devis Détaillé',
    description: 'Proposition personnalisée avec choix du matériel adapté à votre budget et vos attentes'
  },
  {
    numero: '03',
    titre: 'Installation Professionnelle',
    description: 'Pose soignée par un professionnel certifié, avec mise en service et explications complètes'
  },
  {
    numero: '04',
    titre: 'Suivi & Entretien',
    description: "Contrat d'entretien annuel pour maintenir les performances et respecter la réglementation"
  }
];

const faqs = [
  {
    question: 'Quel type de climatisation choisir pour ma maison à Valence ?',
    answer:
      "Pour une maison à Valence, je recommande un climatiseur réversible qui assure chauffage et rafraîchissement. Le système split mono ou multi-split est idéal selon le nombre de pièces. Pour une pièce unique, un split mural suffit. Pour plusieurs pièces, un multi-split avec unités intérieures dans chaque espace offre un confort optimal. Je vous conseille lors du diagnostic gratuit."
  },
  {
    question: "Combien coûte l'installation d'une climatisation à Valence ?",
    answer:
      "Le prix varie selon le type de système et la configuration de votre logement. Je vous fournis un devis détaillé gratuit après visite à domicile pour évaluer précisément vos besoins."
  },
  {
    question: "L'entretien de climatisation est-il obligatoire ?",
    answer:
      "Oui, l'entretien annuel est obligatoire pour les climatisations de plus de 2 kg de fluide frigorigène (environ 4 kW). Cette maintenance assure le bon fonctionnement, prolonge la durée de vie, maintient les performances énergétiques et respecte la réglementation. Je propose des contrats d'entretien à Valence et communes alentour."
  },
  {
    question: 'Intervenez-vous rapidement pour un dépannage de climatisation ?',
    answer:
      "Oui, j'interviens rapidement à Valence, Bourg-lès-Valence, Guilherand-Granges et Portes-lès-Valence pour tout dépannage de climatisation. Panne de compresseur, fuite de gaz, problème électrique : je diagnostique et répare dans les meilleurs délais pour rétablir votre confort."
  },
  {
    question: 'Quelles marques de climatisation installez-vous ?',
    answer:
      "J'installe des marques reconnues pour leur fiabilité : Daikin, Mitsubishi Electric, Atlantic, Toshiba, Panasonic et LG. Ces équipements offrent d'excellentes performances énergétiques (classe A+++), sont silencieux et bénéficient de garanties constructeur solides. Je vous oriente vers le meilleur rapport qualité-prix selon votre projet."
  },
  {
    question: "Existe-t-il des aides financières pour l'installation d'une climatisation ?",
    answer:
      "Oui, certaines aides peuvent être disponibles pour les pompes à chaleur air-air réversibles : MaPrimeRénov', CEE (Certificats d'Économies d'Énergie), éco-prêt à taux zéro. Ces aides dépendent de vos revenus et du type d'équipement. Renseignez-vous auprès des organismes compétents (ANAH, votre fournisseur d'énergie) pour connaître votre éligibilité."
  }
];

const temoignages = [
  {
    nom: 'Nathalie B.',
    ville: 'Valence',
    note: 5,
    texte:
      "Installation impeccable d'un split Daikin dans notre salon. Ion est arrivé à l'heure, travail soigné et propre. La climatisation fonctionne parfaitement, on est ravis !"
  },
  {
    nom: 'Karim A.',
    ville: 'Bourg-lès-Valence',
    note: 5,
    texte:
      "Multi-split installé dans 3 pièces. Très professionnel, explications claires sur le fonctionnement. Je recommande vivement pour tout projet de climatisation à Valence."
  },
  {
    nom: 'Céline V.',
    ville: 'Guilherand-Granges',
    note: 5,
    texte:
      "Dépannage rapide de ma climatisation en pleine canicule. Intervention le jour même, problème résolu efficacement. Tarif honnête et travail de qualité."
  }
];

export default function ClimatisationPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Installation Climatisation Valence | Entretien & Dépannage – Ion Certan';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Installateur climatisation à Valence : split mural, multi-split, pompe à chaleur air-air. Entretien et dépannage climatisation. Ion Certan, professionnel certifié. Devis gratuit à Valence, Bourg-lès-Valence, Guilherand-Granges.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/services/climatisation');
    }
    return () => {
      if (metaDesc) {
        metaDesc.setAttribute('content', 'Plombier Chauffagiste et Sanitaire à Valence. Ion Certan, artisan expert en installation climatisation, chauffage, plomberie et rénovation salle de bains. Intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges. Devis gratuit. Noté 5,0 sur Google.');
      }
      if (canonical) {
        canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/');
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/dc57704987cc2cdd479d43740a963e79.jpg"
            alt="Installation climatisation Valence"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/50 to-transparent"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 w-full pt-24 sm:pt-24 pb-12 sm:pb-16">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/40 text-teal-300 px-3 sm:px-4 py-2 rounded-full text-sm font-medium mb-4 sm:mb-6 backdrop-blur-sm">
              <i className="ri-snowflake-line"></i>
              Climatisation à Valence
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Installation &amp; Entretien<br />
              <span className="text-teal-400">Climatisation</span>
            </h1>
            <p className="text-base sm:text-lg text-gray-200 mb-6 sm:mb-8 leading-relaxed">
              Professionnel certifié à{' '}
              <strong className="text-white">Valence</strong>, j'installe votre
              climatisation réversible pour un confort optimal toute l'année.
              Devis gratuit, intervention rapide, garantie décennale.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 mb-8 sm:mb-10">
              <a
                href="tel:+33760705475"
                className="bg-teal-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-400 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 shadow-lg shadow-teal-500/30"
              >
                <i className="ri-phone-line text-xl sm:text-2xl"></i>
                07 60 70 54 75
              </a>
              <a
                href="mailto:ioncertanpro@gmail.com"
                className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                <i className="ri-mail-line text-xl sm:text-2xl"></i>
                Devis gratuit
              </a>
            </div>
            <div className="flex flex-wrap gap-4 sm:gap-6">
              {[
                { icon: 'ri-check-line', text: 'Diagnostic gratuit' },
                { icon: 'ri-check-line', text: 'Intervention rapide' },
                { icon: 'ri-check-line', text: 'Garantie décennale' }
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 text-teal-300 text-sm font-medium"
                >
                  <i className={`${item.icon} text-sm sm:text-base`}></i>
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Pourquoi Choisir Ion Certan ?
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
              Un artisan local de confiance pour votre installation climatisation
              à Valence
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {avantages.map((a, i) => (
              <div
                key={i}
                className="group bg-gray-50 hover:bg-teal-50 border border-gray-100 hover:border-teal-200 p-5 sm:p-7 rounded-2xl transition-all duration-300 hover:shadow-md"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-100 group-hover:bg-teal-200 rounded-xl mb-4 sm:mb-5 transition-colors">
                  <i className={`${a.icon} text-xl sm:text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                  {a.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">{a.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Types de climatisation */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Nos Solutions de Climatisation
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
              Chaque logement est unique — je vous propose la solution la plus adaptée
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {[
              {
                img: 'https://readdy.ai/api/search-image?query=modern%20white%20split%20air%20conditioner%20unit%20mounted%20on%20wall%20in%20clean%20minimalist%20bedroom%20interior%20soft%20natural%20light%20simple%20background&width=600&height=400&seq=clim-split-mural-v2&orientation=landscape',
                titre: 'Split Mural',
                badge: 'Idéal appartement',
                badgeColor: 'bg-teal-100 text-teal-700',
                desc: "Solution parfaite pour une pièce unique. Silencieux, efficace et discret, le split mural est le choix numéro 1 pour les appartements et studios à Valence.",
                points: [
                  "1 unité intérieure",
                  "Jusqu'à 35 m²",
                  "Devis gratuit sur demande"
                ]
              },
              {
                img: 'https://readdy.ai/api/search-image?query=multi%20split%20air%20conditioning%20system%20multiple%20indoor%20units%20installed%20in%20modern%20open%20plan%20house%20living%20room%20dining%20area%20bright%20interior%20professional%20installation&width=600&height=400&seq=clim-multisplit-v2&orientation=landscape',
                titre: 'Multi-Split',
                badge: 'Idéal maison',
                badgeColor: 'bg-orange-100 text-orange-700',
                desc: "Climatisez plusieurs pièces avec une seule unité extérieure. Chaque pièce dispose de son propre réglage indépendant pour un confort personnalisé.",
                points: [
                  '2 à 5 unités intérieures',
                  'Toute la maison',
                  'Devis gratuit sur demande'
                ]
              },
              {
                img: 'https://readdy.ai/api/search-image?query=heat%20pump%20air%20to%20air%20reversible%20system%20outdoor%20unit%20installed%20on%20modern%20house%20exterior%20wall%20garden%20green%20plants%20energy%20efficient%20technology&width=600&height=400&seq=clim-pac-v2&orientation=landscape',
                titre: 'Pompe à Chaleur Air-Air',
                badge: 'Meilleur rendement',
                badgeColor: 'bg-green-100 text-green-700',
                desc: "Système réversible 2-en-1 : rafraîchit en été et chauffe en hiver. Très économique avec un COP jusqu'à 4. Éligible aux aides MaPrimeRénov'.",
                points: [
                  'Chauffage + climatisation',
                  'COP jusqu\'à 4',
                  'Aides financières'
                ]
              }
            ].map((sol, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 border border-gray-100"
              >
                <div className="h-44 sm:h-52 w-full overflow-hidden">
                  <img
                    src={sol.img}
                    alt={sol.titre}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <div className="flex items-center justify-between mb-2 sm:mb-3">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                      {sol.titre}
                    </h3>
                    <span
                      className={`text-xs font-semibold px-2 sm:px-3 py-0.5 sm:py-1 rounded-full ${sol.badgeColor}`}
                    >
                      {sol.badge}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 leading-relaxed mb-3 sm:mb-4">
                    {sol.desc}
                  </p>
                  <ul className="space-y-1.5 sm:space-y-2">
                    {sol.points.map((p, j) => (
                      <li
                        key={j}
                        className="flex items-center gap-2 text-sm text-gray-700"
                      >
                        <i className="ri-check-line text-teal-500 text-sm sm:text-base"></i>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Comment Ça Se Passe ?
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
              Un processus simple et transparent de A à Z
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8 relative">
            {processus.map((etape, i) => (
              <div key={i} className="relative">
                <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-600 text-white text-lg sm:text-xl font-bold rounded-2xl shrink-0">
                    {etape.numero}
                  </div>
                  {i < processus.length - 1 && (
                    <div className="hidden lg:block flex-1 h-0.5 bg-teal-100"></div>
                  )}
                </div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2">
                  {etape.titre}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {etape.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Marques */}
      <section className="py-10 sm:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">
              Marques Installées
            </h2>
            <p className="text-gray-500 text-xs sm:text-sm">
              Uniquement des équipements reconnus pour leur fiabilité et
              performance
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
            {marques.map((m, i) => (
              <div
                key={i}
                className="bg-white border border-gray-100 rounded-xl p-3 sm:p-4 text-center hover:shadow-md transition-shadow"
              >
                <div className="text-sm sm:text-base font-bold text-gray-800 mb-1">
                  {m.name}
                </div>
                <div className="flex items-center justify-center gap-0.5 sm:gap-1">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-xs text-gray-500">{m.note}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contenu SEO */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Installation de Climatisation à Valence : Votre Expert Local
          </h2>
          <div className="space-y-6 text-gray-600 text-base leading-relaxed">
            <p>
              Vous recherchez un{' '}
              <strong className="text-gray-900">
                installateur de climatisation à Valence
              </strong>
              ? En tant que plombier chauffagiste professionnel, j'accompagne les
              particuliers et professionnels dans leur projet de climatisation
              pour améliorer le confort thermique. Que vous souhaitiez installer
              une{' '}
              <strong className="text-gray-900">
                climatisation réversible
              </strong>
              , un système split ou multi-split, je vous propose des solutions
              adaptées à vos besoins et à votre budget.
            </p>
            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-3">
              Installation Professionnelle à Valence et Alentour
            </h3>
            <p>
              L'
              <strong className="text-gray-900">
                installation d'une climatisation
              </strong>
              nécessite un savoir-faire technique précis. Je réalise une pose
              conforme aux normes en vigueur : fixation des unités, passage des
              liaisons frigorifiques, raccordement électrique, mise en service
              et contrôle d'étanchéité. Mon intervention couvre{' '}
              <strong className="text-gray-900">
                Valence, Bourg-lès-Valence, Guilherand-Granges,
                Portes-lès-Valence
              </strong>{' '}
              et les communes environnantes.
            </p>
            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-3">
              Entretien Obligatoire de Climatisation
            </h3>
            <p>
              L'
              <strong className="text-gray-900">
                entretien annuel de climatisation
              </strong>{' '}
              est obligatoire pour les systèmes contenant plus de 2 kg de fluide
              frigorigène. Cette maintenance préventive comprend : nettoyage
              des filtres et unités, contrôle du fluide frigorigène, vérification
              des connexions électriques, test de performance. Un entretien
              régulier prolonge la durée de vie de votre climatisation et
              maintient son efficacité énergétique.
            </p>
            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-3">
              Dépannage Rapide de Climatisation à Valence
            </h3>
            <p>
              Votre climatisation ne refroidit plus ? Elle fait du bruit ? Elle
              fuit ? J'interviens rapidement pour tout{' '}
              <strong className="text-gray-900">
                dépannage de climatisation à Valence
              </strong>
              . Les pannes courantes incluent : manque de gaz réfrigérant,
              compresseur défaillant, carte électronique HS, encrassement des
              filtres. Je diagnostique l'origine du problème et vous propose une
              réparation durable.
            </p>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Avis de Nos Clients
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
              La satisfaction de nos clients à Valence et alentour
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {temoignages.map((t, i) => (
              <div
                key={i}
                className="bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="flex items-center gap-1 mb-3 sm:mb-4">
                  {Array.from({ length: t.note }).map((_, j) => (
                    <i
                      key={j}
                      className="ri-star-fill text-amber-400 text-sm sm:text-base"
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed mb-4 sm:mb-5 italic">
                  "{t.texte}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-100 rounded-full">
                    <i className="ri-user-line text-teal-600 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">
                      {t.nom}
                    </div>
                    <div className="text-xs text-gray-400">{t.ville}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-gray-500 text-sm sm:text-base">
              Tout ce que vous devez savoir sur la climatisation à Valence
            </p>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border border-gray-100 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="text-base font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i
                      className={`${
                        openFaq === i ? 'ri-subtract-line' : 'ri-add-line'
                      } text-teal-600 text-lg`}
                    ></i>
                  </div>
                </button>
                {openFaq === i && (
                  <div className="px-6 pb-5">
                    <p className="text-sm text-gray-500 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-14 sm:py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20home%20interior%20with%20air%20conditioning%20comfort%20summer%20cool%20temperature%20living%20room%20bright%20clean%20minimalist%20design&width=1440&height=600&seq=clim-cta-bg-v2&orientation=landscape"
            alt="Climatisation confort Valence"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-teal-700/90"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4">
            Besoin d'une Climatisation à Valence ?
          </h2>
          <p className="text-teal-100 text-base sm:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto">
            Contactez-moi dès aujourd'hui pour un diagnostic gratuit et un devis
            personnalisé sans engagement
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 mb-6 sm:mb-8">
            <a
              href="tel:+33760705475"
              className="bg-white text-teal-700 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 shadow-lg"
            >
              <i className="ri-phone-line text-lg sm:text-xl"></i>
              Appeler maintenant
            </a>
            <a
              href="mailto:ioncertanpro@gmail.com"
              className="bg-teal-600 text-white border border-teal-400 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-bold hover:bg-teal-500 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line text-lg sm:text-xl"></i>
              Envoyer un email
            </a>
          </div>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-teal-200 text-xs sm:text-sm">
            <span className="flex items-center gap-1">
              <i className="ri-map-pin-line"></i> Valence &amp; alentours
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i> Réponse sous 24h
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-file-list-line"></i> Devis gratuit
            </span>
          </div>
        </div>
      </section>

      {/* Breadcrumb / Retour */}
      <div className="bg-gray-50 py-3 sm:py-4 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-teal-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Retour à l'accueil
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
}
